import Vue from 'vue'

Vue.component('PaginationLink', {
  template: '#vue-pagination-link-template',
  props: ['number', 'url', 'active'],
  data() {
    return {
      isActive: false,
    }
  },
  methods: {
    setActive() {
      this.$props.active === this.$props.number ? (this.isActive = true) : (this.isActve = false)
    },
  },
  mounted() {
    this.setActive()
  },
})
